exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-3839abaa] .md-disabled .md-list-item-text {\n  color: #eee;\n}\n", ""]);

// exports
